export const ALLOWED_FILE_TYPES = ['.jpg', '.pdf', '.png', '.jpeg']